import script from "./cost-detail-dialog.vue?vue&type=script&lang=tsx&setup=true"
export * from "./cost-detail-dialog.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__